
<search
  ref="search"
  class="card-search"
  source="cards"
  sort="numSales"
  :include-hidden="includeHidden"
  v-bind="$attrs"
  :placeholder="placeholder"
  v-on="$listeners"
>
  <template #default="slotProps">
    <card-list-item :card="slotProps.item" :fields="['currentValue']" />
  </template>
</search>
